<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';
    import Input from '../Input';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        type?: 'text' | 'number' | 'tel' | 'password' | 'email' | 'date';
        maxlength?: number;
    }>();
</script>

<template>
    <Input
        data-slot="input-group-control"
        :type="type"
        :class="cn('flex-1 rounded-none border-0 bg-transparent! shadow-none focus-visible:ring-0 px-0', props.class)"
        :maxlength="maxlength"
    />
</template>
